module.exports = __webpack_public_path__ + "img/upper-left.9f573456.svg";